import { tokenService } from '@/lib/token.service'
import * as Sentry from '@sentry/react'

export interface SentryConfig {
  dsn: string
  environment: string
  enabled: boolean
  tracesSampleRate: number
}

const getSentryConfig = (): SentryConfig => {
  const environment = import.meta.env.VITE_NODE_ENV
  const dsn = import.meta.env.VITE_SENTRY_DSN

  return {
    dsn,
    environment,
    enabled: !!dsn && environment === 'production',
    tracesSampleRate: 0.5,
  }
}

export const initializeSentry = () => {
  const config = getSentryConfig()

  if (!config.enabled) {
    console.info('Sentry is disabled in development or missing DSN')
    return
  }

  Sentry.init({
    dsn: config.dsn,
    environment: config.environment,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: config.tracesSampleRate,
    replaysOnErrorSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    sendDefaultPii: true,
    beforeSend(event) {
      event.user = {
        id: tokenService?.getUser()?.id,
        email: tokenService?.getUser()?.email,
      }

      return event
    },
  })
}

export { Sentry }
